// Base configuration shared across all stages
const base_config = {
  // Cognito common settings
  TOKEN_SCOPES_ARRAY: ["openid"],
  REGION: "us-west-2",
  OAUTH_RESPONSE_TYPE: "code",
  // Use getter to ensure runtime evaluation
  get CALL_BACK_URL() {
    return window.location.origin;
  },
  REFRESH_TOKEN_VALIDITY: 1,
  HOME_DOC_ID: 1,
  
  // Authentication provider: 'AmazonFederate' or 'LASSO'
  // Override this in stage-specific configs to switch providers
  AUTH_PROVIDER: 'LASSO', // Default to AmazonFederate
};

export default base_config;
